import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Media from '@src/components/MediaBigPhoto';
import IconLoading from '@src/components/IconLoading';
import {
	IconPlay,
	IconArrLeftBig as IconArrLeft,
	IconArrRightBig as IconArrRight,
} from '@src/components/Icon';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const MediaBigManage = (props) => {
	useStyles(css);
	const {
		media,
		onClickPrev,
		onClickNext,
		onClickPlay,
		onLoad,
		onLoadStart,
		isLoading,
	} = props;

	return (
		<div className={css.wrap}>
			{onClickPrev && (
				<div
					className={cn(css.icon, css.iconArrLeft)}
					onClick={onClickPrev}
					tabIndex={0}
					role="button"
				>
					<IconArrLeft />
				</div>
			)}

			{media && (
				<Media
					mix={cn(css.media, { [css.media_loading]: isLoading })}
					onLoad={onLoad}
					onLoadStart={onLoadStart}
					{...media}
				/>
			)}
			{isLoading && (
				<div className={css.loader}>
					<IconLoading size="big" color="grey" />
				</div>
			)}
			{onClickPlay && media.isVideo && (
				<div
					className={cn(css.icon, css.iconPlay)}
					onClick={onClickPlay}
					tabIndex={0}
					role="button"
				>
					<IconPlay />
				</div>
			)}

			{onClickNext && (
				<div
					className={cn(css.icon, css.iconArrRight)}
					onClick={onClickNext}
					tabIndex={0}
					role="button"
				>
					<IconArrRight />
				</div>
			)}
		</div>
	);
};

MediaBigManage.propTypes = {
	media: PropTypes.shape({
		...Media.type.propTypes,
		isVideo: PropTypes.bool,
	}),
	onLoad: PropTypes.func,
	isLoading: PropTypes.bool,
	onClickPrev: PropTypes.func,
	onClickNext: PropTypes.func,
	onClickPlay: PropTypes.func,
	onLoadStart: PropTypes.func,
	isWatchLoading: PropTypes.bool,
};

MediaBigManage.defaultProps = {
	media: undefined,
	onClickPrev: undefined,
	onClickNext: undefined,
	onClickPlay: undefined,
	isWatchLoading: false,
	onLoad: undefined,
	onLoadStart: undefined,
	isLoading: undefined,
};

export default MediaBigManage;
